import React from 'react';
import Cards from '../Cards';
import { useLocation } from 'react-router-dom';

const Masterdata = () =>{
    const formattedPath = useLocation().pathname.split("/").filter(x => x!== "");
    const pathprop = formattedPath[formattedPath.length -1]
    console.log(pathprop)
  
    return(
        <Cards pathValue ={pathprop} />
    )
}

export default Masterdata;